import { observer } from 'mobx-react-lite'
import { Box } from 'shared/ui'
import { makeTextFieldClear, makeTextFieldIcon, TextField } from 'shared/ui/TextField'
import { Table } from 'shared/ui/TableNew'
import { ContactStatisticBulkActions } from 'widgets/ContactStatistic'
import { useViewPageContext } from 'pages/surveys/pages/view/context/viewContext'
import { columns } from 'pages/surveys/pages/view/ui/ContactsTable/columns'
import styles from './styles.module.scss'

export const ContactsTable = observer(() => {
  const {
    items,
    tableStore,
    search,
    setSearch,
    onOpenContactsDetails,
    contactsTagsModalStore,
    selectedContactIds,
    onSuccessDelete,
    onSuccessManageTags,
  } = useViewPageContext()

  return (
    <Box display={'flex'} flexDirection={'column'} flex={1} marginInline={'16px'}>
      <div className={styles.search}>
        <TextField
          onChange={setSearch}
          variant={'integrated'}
          value={search}
          InputProps={{ placeholder: 'Search...' }}
          leftActions={[
            makeTextFieldIcon({
              icon: 'search',
              fontSize: 18,
              color: 'var(--content-primary-tertiary)',
              margin: '0 9px 0 4px',
            }),
          ]}
          rightActions={[
            makeTextFieldClear({
              isButton: true,
              isVisibleWithoutFocus: true,
              intent: 'passive',
            }),
          ]}
        />
      </div>
      <Box display={'flex'} flexDirection={'column'} flex={1} className={styles.tableWrap}>
        <Table
          virtualization
          ariaLabel={'SurveyContacts'}
          pinnedColumnIds={['contact_name']}
          store={tableStore}
          columns={columns(onOpenContactsDetails)}
          rows={items}
          withCheckbox
          headerLeftContentProps={{
            actionsContent: (
              <ContactStatisticBulkActions
                contactsTagsModalStore={contactsTagsModalStore}
                selectedContactIds={selectedContactIds}
                search={search}
                onSuccessDelete={onSuccessDelete}
                onSuccessManageTags={onSuccessManageTags}
                withNewActions
              />
            ),
          }}
        />
      </Box>
    </Box>
  )
})
